import {writable} from "../_snowpack/pkg/svelte/store.js";
export const motion = writable("safe");
export const location = writable("home");
export const current = writable(true);
